/**
 * Servicio de login
 */
import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {Validators, FormGroup, FormBuilder} from "@angular/forms";
import {LoginObject} from "../../models/login-object.model";
import {AuthenticationService} from "../../services/authentication.service";
import {StorageService} from "../../services/storage.service";
import {Router} from "@angular/router";
import { Session } from "../../models/session.model";
import { UtilsService } from "../../services/utils.service";


@Component({
  selector: 'login',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss'] ,
  providers:[AuthenticationService, StorageService],
  encapsulation: ViewEncapsulation.None
})

export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public submitted: Boolean = false;
  public error: {code: number, message: string} = null;

  constructor(private formBuilder: FormBuilder,
              private authenticationService: AuthenticationService,
              private storageService: StorageService,
              private utilsService: UtilsService,
              private router: Router) { }

  ngOnInit() {
    // por si no hicimos logout y borramos la tienda, reseteamos al llegar aqui
    // si nos pide login que tambien nos pida tienda
    this.utilsService.clearCurrentTiendaId();
    // Inicializamos el formulario
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    })
  }

  get f() { return this.loginForm.controls; }

  public submitLogin(): void {
    //Lo primero es borrar la sesión, para evitar problemas
    this.storageService.removeCurrentSession();

    this.submitted = true;
    this.error = null;
    if(this.loginForm.valid){
      this.authenticationService.login(new LoginObject(this.loginForm.value)).subscribe(
        data => this.correctLogin(data),
        error => {
          this.error = error;
        }
      )
    }
  }

  private correctLogin(data: Session){
    this.storageService.setCurrentSession(data);
    this.router.navigate(['/main']);
  }
}
